module.exports = __webpack_public_path__ + "static/media/Demo.83a6481.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mov/Demo.mp4
// module id = DUG4
// module chunks = 1